export const REGEXES = {
  AMOUNT: /^\d*\.?\d{0,2}$/,
};
